var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProcessFBMReportTableAdmin',{attrs:{"results":_vm.results,"dataRightBlock":_vm.dataRightBlock,"adminOptions":_vm.adminOptions},on:{"filter":_vm.filter}})
}
var staticRenderFns = []

export { render, staticRenderFns }